import React, { useEffect } from "react";

import { CustomButton } from "../common/custombutton";
import { useAudio } from "./useAudio";

const UserList = ({ users }) => {
  const { audio, ready } = useAudio({ src: "./1.mp3" });
  

  const playAudioDefalt = () => {
    if (ready) {
        audio.play();
    }
  }


  return (
    <div>
      <CustomButton click={playAudioDefalt} classname="draw" text="Play Audio Background" />
      <CustomButton classname="meet draw" text="Play When Done" />
    </div>
  );
};

export default UserList;
